import React from 'react';
import {Box, TextField, Typography} from '@mui/material';
import {useTranslation} from "react-i18next";

export default function ToolDetailsStep({toolDetails, setToolDetails, errors}) {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
        > <Typography variant="h5" mb={5}>
            {t("steps.tool_details")}
        </Typography>

            <Box
                sx={{
                    width: '100%',
                    maxWidth: 500,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="body1" mb={1} color="text.primary">
                    {t("tool_details.name_help")}
                </Typography>
                <TextField
                    variant="outlined"
                    label={t("tool_details.name")}
                    value={toolDetails.name}
                    onChange={(e) => setToolDetails({...toolDetails, name: e.target.value})}
                    fullWidth
                    required
                    error={Boolean(errors?.name)}
                    helperText={errors?.name}
                />
                <Typography variant="body1" color="text.primary" mt={5} mb={1}>
                    {t("tool_details.description_help")}
                </Typography>
                <TextField
                    variant="outlined"
                    label={t("tool_details.description")}
                    value={toolDetails.description}
                    onChange={(e) => setToolDetails({...toolDetails, description: e.target.value})}
                    multiline
                    rows={4}
                    fullWidth
                />
            </Box>
        </Box>
    );
}
